import { StackPlanViewModel } from '../../state/sp-view-state.model';
import { FloorWithBuildingInfo, PVColumn } from '../shared/column.model';
import { formatFullFloorDetails } from '../shared/utils';

export const getPVColumns = (context: StackPlanViewModel): PVColumn[] =>
  [
    {
      columnId: 90000,
      field: 'floor_number',
      dataType: 'numeric',
      header: 'Floor',
    },
    {
      columnId: 90001,
      field: 'floor_size',
      dataType: 'numeric',
      header: 'Floor Area',
      unit: {
        columnId: 90002,
        field: 'floor_size_uom_desc',
        dataType: 'string',
        header: 'Rentable Sq Ft UOM',
      },
      options: {
        format: '0.0-0',
      },
      displayFn: (data, _s, _m, column) => formatFullFloorDetails.getFloorSize(data as FloorWithBuildingInfo, column),
      cssClass: 'lease-info-column--area',
    },
    {
      columnId: 90003,
      field: 'floor_slab_height',
      dataType: 'string',
      header: 'Slab Height',
      displayFn: data => formatFullFloorDetails.getFloorSlabHeight(data as FloorWithBuildingInfo),
      cssClass: 'lease-info-column--slab-height',
    },
    {
      columnId: 90004,
      field: 'party_organization_display_name',
      dataType: 'string',
      header: 'Tenants',
      displayFn: data => formatFullFloorDetails.getTenantValueToDisplay(data as FloorWithBuildingInfo, context),
      cssClass: 'lease-info-column--tenant',
    },
    {
      columnId: 90005,
      field: 'arrangement_end_date',
      dataType: 'date',
      header: 'End Date',
      displayFn: data => formatFullFloorDetails.getTenantEndDate(data as FloorWithBuildingInfo, context),
    },
  ].map(c => ({ ...c }));
